module.exports = __webpack_public_path__ + "images/program/computerPixel.585441bd.svg";